<template>
  <v-row
    dense
    no-gutters
    class="cart-item align-content-center text-body-1 pl-5 pb-2 pt-2"
  >
    <BtnRemove @remove="removeCartItem(item)" />
    <v-col cols="5" sm="5" class="item-name">{{ item.name }}</v-col>
    <v-col cols="4" sm="4">
      &times; {{ quantity }}
      <!-- <v-text-field
        type="Number"
        :class="['item-quantity', { large: ['sm', 'xs'],$mq) }]"
        dense
        hide-details
        reverse
        v-model="quantity"
        min="0"
        :max="itemStock"
        :rules="[notExceedsStockRule]"
      />       -->
      <span v-if="unit"> @ {{ unit }}</span>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="3" sm="3" class="text-right font-weight-bold"
      >${{ (quantity * item.price_usd).toFixed(2) }}</v-col
    >
    <v-col
      v-if="isOversold"
      cols="12"
      class="font-italic blue--text text--darken-2"
      >Inventory Reduced</v-col
    >
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import _get from 'lodash/get'

import BtnRemove from '@/components/BtnRemove'

export default {
  name: 'CartItem',
  components: {
    BtnRemove,
  },
  props: {
    cartItem: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  created() {
    this.quantity = this.cartItem.quantity
  },
  computed: {
    item() {
      return _get(this.cartItem, 'item')
    }, // item
    unit() {
      if (!this.cartItem.unit) return false
      let trimmedUnit = this.cartItem.unit.trim()
      return trimmedUnit ? trimmedUnit : false
    }, // unit
    quantity: {
      get() {
        return this.cartItem.quantity || 1
      },
      set(quantity) {
        if (quantity > 0) {
          this.updateCartItem({ ...this.cartItem, quantity })
        } else {
          this.removeCartItem(this.cartItem)
        }
      },
    },
    stockRemaining() {
      return this.itemStock - this.quantity
    }, // stockRemaining
    itemStock() {
      if (this.unlimitedStock) return Infinity
      return _get(this.item, 'stock', Infinity)
    }, // itemStock
    unlimitedStock() {
      return _get(this.item, 'unlimited', false)
    }, // unlimitedStock
    isOversold() {
      return _get(this, 'cartItem.oversold', false)
    }, // isOversold
  },
  methods: {
    ...mapActions('cart', ['updateCartItem', 'removeCartItem']),
    updatePrice(price) {
      let updatedItem = { ...this.cartItem }
      updatedItem.price = price
      this.updateCartItem(updatedItem)
    }, // updatePrice
  },
  data() {
    return {
      notExceedsStockRule: (v) => {
        if (!v) return true
        else return this.stockRemaining >= 0
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.cart-item {
  position: relative;
  line-height: 1.3 !important;
  &:not(:last-of-type) {
    border-bottom: 1px dotted lighten(black, 85);
  }
  .item-name {
    align-self: center;
  }
}
.close-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
